export default "__VITE_ASSET__DKV3hfBY__"